import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=5198dca4&"
import script from "./MediaViewer.vue?vue&type=script&lang=js&"
export * from "./MediaViewer.vue?vue&type=script&lang=js&"
import style0 from "./MediaViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports